<template>
  <div class="vol-pay-notice">
    <div class="vol-pay-notice-row">
      <span class="vol-pay-balance">
        <span class="vol-pay-balance-label">当前余额</span>
        <AppIcon name="orangeCoin" size="sm" />
        <span>{{ balanceGold }}</span>
      </span>
      <button type="button" class="vol-pay-notice-toggle" @click="noticeOpen = !noticeOpen">
        购买须知
        <span class="vol-pay-notice-caret" :class="{ 'is-open': noticeOpen }">∨</span>
      </button>
    </div>
    <p v-if="noticeOpen" class="vol-pay-agree">
      购买即同意
      <button type="button" class="vol-pay-agree-link" @click="openAgreement">
        《{{ agreementTitle }}》
      </button>
    </p>
  </div>
</template>

<script setup>
/**
 * @file VolPayNoticeFold.vue
 * @description 购卷弹窗共用：当前余额 + 购买须知折叠（展开后点开协议弹窗）
 */
import { ref } from 'vue'
import AppIcon from '@/shared/components/AppIcon.vue'

defineProps({
  /** 当前橘子币余额 */
  balanceGold: { type: Number, default: 0 },
  /** 协议标题，不含书名号 */
  agreementTitle: { type: String, default: '橘子漫嘎付费内容购买协议' },
  openAgreement: { type: Function, required: true },
})

const noticeOpen = ref(false)
</script>

<style scoped>
.vol-pay-notice {
  margin-bottom: var(--spacing-sm);
}

.vol-pay-notice-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-sm);
}

.vol-pay-balance {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  font-size: var(--font-size-small);
  line-height: var(--line-height-normal);
  color: var(--color-text-regular);
}

.vol-pay-balance-label {
  color: var(--color-text-secondary);
}

.vol-pay-notice-toggle {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  border: none;
  background: none;
  padding: 0;
  font-size: var(--font-size-small);
  line-height: var(--line-height-normal);
  color: var(--color-text-secondary);
  cursor: pointer;
}

.vol-pay-notice-caret {
  display: inline-block;
  transition: transform var(--transition-base, 0.2s);
}

.vol-pay-notice-caret.is-open {
  transform: rotate(180deg);
}

.vol-pay-agree {
  margin: var(--spacing-sm) 0 0;
  padding: var(--spacing-sm);
  border-radius: var(--radius-base);
  background: var(--color-bg-light, #fafafa);
  font-size: var(--font-size-small);
  line-height: var(--line-height-normal);
  color: var(--color-text-secondary);
}

.vol-pay-agree-link {
  border: none;
  background: none;
  padding: 0;
  color: var(--color-primary);
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
}
</style>
